import DiscountType from '@/constants/subBubbleAgreement/SubBubbleAgreementDiscountType'

export default class SubBubbleAgreementDiscountViewModel {
  constructor({
    id,
    subBubbleAgreementId = null,
    classificationId = null,
    classificationName = null,
    discountType = DiscountType.PERCENT,
    value = null,
    isClassificationDiscount = false,
    candidateCount = 1,
  } = {}) {
    /**
     * @type {Number}
     */
    this.id = id
    /**
     * @type {Number}
     */
    this.subBubbleAgreementId = subBubbleAgreementId
    /**
     * @type {Number}
     */
    this.classificationId = classificationId
    /**
     * @type {String}
     */
    this.classificationName = classificationName
    /**
     * @type {DiscountType}
     */
    this.discountType = discountType
    /**
     * @type {Number}
     */
    this.value = value
    /**
     * @type {Boolean}
     */
    this.isClassificationDiscount = isClassificationDiscount
    /**
     * @type {Number}
     */
    this.candidateCount = candidateCount
  }
}
